import {
	GuildData,
	DiscordAuthToken,
	WebDashboardType,
} from "../../../common/sesh_types";
import React from "react";
import FadeIn from "../../../src/vendored/FadeIn";
import { DashboardUtils, FADE_IN_ANIMATION_DURATION } from "./dashboard_utils";
import { common_utils } from "../../../common/common_utils";
import { RouteComponentProps, useHistory } from "react-router";
import { setDocTitle } from "./web_ui";
import { Tag } from "./forms/improved_components/base_components/tag";

export interface GuildOptionsFormProps extends RouteComponentProps {
	guild_data: GuildData;
	auth_token: DiscordAuthToken;
}

function ListButton(props: { is_event: boolean; server_id: string }) {
	const label = props.is_event ? "Events" : "Polls";
	const history = useHistory();

	return (
		<span
			title={props.is_event ? "Event Listings" : "Poll Listings"}
			onClick={() =>
				history.push(
					props.is_event
						? common_utils.getEventListURL(props.server_id)
						: common_utils.getPollListURL(props.server_id)
				)
			}
		>
			<div className="columns is-mobile is-vcentered is-variable is-1 margin-link">
				<div className="column is-narrow">
					{props.is_event ? (
						<i className="far fa-calendar-alt"></i>
					) : (
						DashboardUtils.GetListIcon()
					)}
				</div>
				<div className="column is-narrow">
					{props.is_event ? (
						<div className="flex gap-2">
							<span>{label}</span>
							<Tag type={"Dark"}>new</Tag>
						</div>
					) : (
						label
					)}
				</div>
			</div>
		</span>
	);
}

function BackToServerButton(props: {}) {
	const history = useHistory();

	return (
		<div
			className="columns is-mobile is-vcentered is-variable is-1 margin-link"
			onClick={() => history.push("/dashboard/")}
		>
			<div className="column is-narrow">
				{DashboardUtils.GetBackIcon()}
			</div>
			<div className="column is-narrow">Servers</div>
		</div>
	);
}

function OptionsTopMarginElement(props: { server_id: string }) {
	return (
		<div className="columns is-mobile options-margin-items is-size-6-tablet">
			<div className="column is-narrow">
				<BackToServerButton />
			</div>
			<div className="column is-narrow right-aligned">
				<div className="columns is-mobile is-multiline">
					<div className="column is-narrow">
						<ListButton
							is_event={true}
							server_id={props.server_id}
						/>
					</div>
					<div className="column is-narrow">
						<ListButton
							is_event={false}
							server_id={props.server_id}
						/>
					</div>
				</div>
			</div>
		</div>
	);
}

export class GuildOptionsForm extends React.Component<GuildOptionsFormProps> {
	constructor(props) {
		super(props);

		if (!this.props.guild_data) {
			DashboardUtils.ShowDefaultErrorAlert("Invalid Guild Data");
			// goToGuildSelectionDashboard(
			// 	this.props.fragment,
			// 	this.props.auth_token
			// );
			// return;
		}

		// const state = common_utils.createWebServerSelectURLState(
		// 	this.props.bot_client_id,
		// 	this.props.guild_data.id
		// );
		//history.replaceState(null, "", `/dashboard/#state=${state}`);

		setDocTitle(this.props.guild_data.name);
	}

	render() {
		const containerClassName =
			"column is-11-mobile is-three-quarters-tablet is-three-quarters-desktop is-half-widescreen is-two-fifths-fullhd create-event-container is-centered";

		return (
			<FadeIn transitionDuration={FADE_IN_ANIMATION_DURATION}>
				<div
					className="columns is-centered is-mobile !m-0 w-full"
					style={{ transition: "opacity 0.5s", opacity: "1" }}
				>
					<div className={containerClassName}>
						<OptionsTopMarginElement
							server_id={this.props.guild_data.id}
						/>
						<div>
							<h1 className="title is-3 has-text-centered !mb-8">
								{DashboardUtils.LimitGuildName(
									this.props.guild_data.name,
									true
								)}
							</h1>
							<div className="columns is-mobile is-multiline is-centered">
								<div className="column is-10-tablet is-8-desktop is-11-mobile has-text-centered">
									<div className="columns is-mobile is-multiline is-centered is-variable is-2">
										<div className="column is-narrow">
											<DashboardUtils.CreateOptionsButton
												button_name="Create Event"
												icon={DashboardUtils.GetEventIcon()}
												on_click={(history) =>
													history.push(
														common_utils.getEventCreateURL(
															this.props
																.guild_data.id
														)
													)
												}
												needs_history={true}
											/>
											<br />
											<br />
											<DashboardUtils.CreateOptionsButton
												button_name="Create Poll"
												icon={DashboardUtils.GetPollIcon()}
												on_click={(history) =>
													history.push(
														common_utils.getPollCreateURL(
															this.props
																.guild_data.id
														)
													)
												}
												needs_history={true}
											/>
											<br />
											<br />
											<DashboardUtils.CreateOptionsButton
												button_name="Time Finder"
												icon={
													<i className="fas fa-clock fa-lg title-icon"></i>
												}
												on_click={(history) =>
													history.push(
														common_utils.getTimeFinderURL(
															{
																server_id:
																	this.props
																		.guild_data
																		.id,
																type: "base",
															}
														)
													)
												}
												needs_history={true}
											/>
											<br />
											<br />
											<DashboardUtils.CreateOptionsButton
												button_name="Settings"
												icon={DashboardUtils.GetSettingsIcon()}
												on_click={(history) =>
													history.push(
														common_utils.getGuildSettingsURL(
															this.props
																.guild_data.id
														)
													)
												}
												needs_history={true}
											/>
										</div>
									</div>
								</div>
								<div className="column is-full"></div>
							</div>
						</div>
					</div>
				</div>
			</FadeIn>
		);
	}
}
